import type { Card } from '@/modules/FinancialPlanning/ui/Widgets/Home';
import type { FC } from 'react';
import Link from 'next/link';
import { Close, OpenInNewTab } from '@eqi-investimentos/icons/web';
import { Box, Flex, IconButton, Text } from '@eqi-investimentos/react';
import { Collapse, Fade, useDisclosure } from '@chakra-ui/react';
import { Icon } from '../Icon';
export const FloatingButton: FC<FloatingButtonProps> = ({
  options
}) => {
  const {
    isOpen,
    onToggle
  } = useDisclosure();
  return <>
      <Fade in={isOpen} unmountOnExit transition={{
      enter: {
        delay: -0.5
      }
    }} data-sentry-element="Fade" data-sentry-source-file="index.tsx">
        <Box position="fixed" top="0" left="0" w="100vw" h="100vh" bg="blackAlpha.800" zIndex="dropdown" onClick={onToggle} data-sentry-element="Box" data-sentry-source-file="index.tsx" />
      </Fade>
      <Box position="fixed" bottom={14} right={8} zIndex="dropdown" data-sentry-element="Box" data-sentry-source-file="index.tsx">
        <Flex direction="column" gap={3} alignItems="flex-end" data-sentry-element="Flex" data-sentry-source-file="index.tsx">
          {Array.isArray(options) && options.map(({
          text,
          icon,
          href
        }) => <Collapse key={text} in={isOpen} unmountOnExit animateOpacity>
                <Flex as={Link} href={href} onClick={onToggle} gap="s" alignItems="center">
                  <Text fontSize="sm" lineHeight="l" color="content.alwaysLight">
                    {text}
                  </Text>
                  <IconButton aria-label={text} icon={<Icon iconName={icon} width={24} height={24} color="content.alwaysLight" />} bgColor="content.brand" {...buttonProps} />
                </Flex>
              </Collapse>)}
          <IconButton icon={isOpen ? <Close boxSize={6} /> : <OpenInNewTab boxSize={6} />} onClick={onToggle} aria-label="Abrir menu flutuante" {...buttonProps} data-sentry-element="IconButton" data-sentry-source-file="index.tsx" />
        </Flex>
      </Box>
    </>;
};
const buttonProps = {
  justifyContent: 'center',
  boxSize: '3.125rem',
  borderRadius: 'full'
};
type FloatingButtonProps = {
  options?: Card[];
};